import { render, staticRenderFns } from "./MiniStatistic.vue?vue&type=template&id=1001a49c&scoped=true&lang=pug"
import script from "./MiniStatistic.vue?vue&type=script&lang=js"
export * from "./MiniStatistic.vue?vue&type=script&lang=js"
import style0 from "./MiniStatistic.vue?vue&type=style&index=0&id=1001a49c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1001a49c",
  null
  
)

export default component.exports